import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css"; // ✅ Importing styles
import { motion } from "framer-motion"; // ✅ For smooth animations

function Home() {
  return (
    <div className="home-container">
      {/* ✅ Hero Section */}
      <motion.div
        className="hero-section"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <img src="/Homelogo (7).jpg" alt="ChronicTrace Logo" className="home-logo" />
        <h1 className="hero-title">The Future of Concussion Awareness</h1>
        <p className="hero-subtitle">
          Protecting those who push limits—whether in sports, service, or high-risk professions.
        </p>

        <div className="hero-buttons">
          <Link to="/features" className="btn primary-btn">How It Works</Link>
          <Link to="/blog" className="btn secondary-btn">Latest Research</Link>
        </div>
      </motion.div>

      {/* ✅ Fixed Key Features Section */}
      <div className="features-section">
        <h2>Why Choose ChronicTrace?</h2>
        <div className="features-grid">
          <motion.div
            className="feature-box"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <h3>AI-Driven Concussion Alerts</h3>
            <p>Instant recognition of head impact severity through intelligent algorithms.</p>
          </motion.div>

          <motion.div
            className="feature-box"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <h3>Blockchain-Protected Health Records</h3>
            <p>Medical transparency and privacy through decentralized data storage.</p>
          </motion.div>

          <motion.div
            className="feature-box full-width"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <h3>Built for Those Who Take Risks</h3>
            <p>Developed by former athletes and industry experts who understand the stakes.</p>
          </motion.div>
        </div>
      </div>

      {/* ✅ Additional Info Section */}
      <div className="info-section">
        <h2>Our Mission</h2>
        <p>
          ChronicTrace is more than technology, it's a movement to protect lives, careers, and futures.
          With real-time concussion detection, we empower individuals and organizations to take control
          of head trauma before it becomes life-altering.
        </p>
        <p>
          Whether you're on the field, in combat, or in an environment where head impact is a risk, 
          ChronicTrace delivers the insights needed to make informed decisions.
        </p>
      </div>
    </div>
  );
}

export default Home;